import { useIsCustomColorTheme } from "@circle-react/hooks/useIsCustomColorTheme";
import { THEME_MAP, useThemeContext } from "@circle-react/providers/Theme";
import { colord } from "colord";
import type { CSSProperties } from "react";

const sidebarBackgroundCssVar = "--color-community-sidebar-background";

const useSidebarColor = () => {
  const { customColors, isCustomTheme, currentTheme, currentAppearance } =
    useThemeContext();

  const customSidebarColor =
    customColors[currentAppearance]?.sidebar_background_color || "#fff";

  let themeSidebarColor = "#fff";

  if (currentTheme !== "custom") {
    const value =
      THEME_MAP?.[currentTheme]?.[currentAppearance]?.[sidebarBackgroundCssVar];
    if (value) {
      themeSidebarColor = value;
    }
  }

  return isCustomTheme ? colord(customSidebarColor) : colord(themeSidebarColor);
};

export const useCustomSidebarBackgroundColor = () => {
  const sidebarColor = useSidebarColor();
  return sidebarColor.toHex();
};

export const useCustomSidebarBorderColor = () => {
  const sidebarColor = useSidebarColor();

  if (sidebarColor.isDark()) {
    return sidebarColor.lighten(0.1).toHex();
  }
  return sidebarColor.darken(0.1).toHex();
};

export const useSidebarBackgroundStyles = (): CSSProperties => {
  const backgroundColor = useCustomSidebarBackgroundColor();
  const isCustomColorTheme = useIsCustomColorTheme();

  if (isCustomColorTheme) {
    return {
      backgroundColor,
    };
  }
  return {};
};

export const useSidebarBorderStyles = (): CSSProperties => {
  const borderColor = useCustomSidebarBorderColor();
  const isCustomColorTheme = useIsCustomColorTheme();

  if (isCustomColorTheme) {
    return {
      borderColor,
    };
  }
  return {};
};
